/**
 * JourneyRoadBlock — "The Road": one quest as the winding journey ladder, in
 * a Drop surface slot (anchor rttf-drop-hub.html:1967, the `.yp` column
 * widget, kind JOURNEY).
 *
 * A QUEST content block whose displayMode is "Journey" mounts this instead
 * of the link card — the REAL ladder (`SegmentJourneyPath`, the same
 * component and the same `deriveSteps` derivation the play page mounts), not
 * a summary of it. Gap-register rows 8: "what mounts in the slot is a link
 * card... no steps, no progress" — this is the fix.
 *
 * Signed-out viewers get the ladder with no progress rather than a login
 * wall: the quest's authored steps still tell them what the road IS, which
 * is the recruiting surface the anchor treats it as.
 */
import { SegmentJourneyPath } from "@/widgets/play/SegmentJourneyPath";
import { useQuestJourney } from "@/hooks/useQuestJourney";
import "./JourneyRoadBlock.scss";

interface JourneyRoadBlockProps {
    questConfigId?: string;
    sectionTitle?: string;
}

export function JourneyRoadBlock({ questConfigId, sectionTitle }: JourneyRoadBlockProps) {
    const { quest, steps, loading } = useQuestJourney(questConfigId);

    if (!questConfigId) return null;

    if (loading) {
        return (
            <div className="journey-road">
                <div className="journey-road__skeleton" />
            </div>
        );
    }

    if (!quest || steps.length === 0) return null;

    return (
        <div className="journey-road">
            <div className="journey-road__head">
                <span className="journey-road__kicker">{sectionTitle || "The Road"}</span>
                <h3 className="journey-road__title">{quest.name}</h3>
            </div>
            {quest.description &&
                <p className="journey-road__sub">{quest.description}</p>
            }
            <SegmentJourneyPath
                steps={steps}
                milestones={quest.milestones ?? []}
            />
        </div>
    );
}
